import * as React from 'react'
import Loader from '../../../Components/Loader'
import { Modal } from '../../../Components/Modal'
import { AdminIcon } from '../../../Icons/AdminIcon'
import { AdminTimeSlot } from '../AdminBookings';
import '../Adminbookings.css'
interface IAddTimeSlotsModal{
    handleModal:(key:'delete'|'reschedule'|'send_material'|'submit-new-timeslots'|'remove-timeslots') => void;
    timeSlots:AdminTimeSlot[];
    isSavingNewSlots:boolean;
    handleAvailabletimeSlotSubmit:() => Promise<void>;
    hasPendingSlots:boolean;
}
export const AddTimeSlotsModal = ({handleModal,timeSlots,isSavingNewSlots,handleAvailabletimeSlotSubmit,hasPendingSlots}:IAddTimeSlotsModal) => {
    return(
        <Modal  onClose={() => handleModal('submit-new-timeslots')}>
        
        <div style={{cursor:'pointer',width:35}} onClick={()=> handleModal('submit-new-timeslots')}>
             <AdminIcon.CrossClose fill='hsl(var(--primary))'/>
           </div>
      <div className="sheet-header-container">
        <h2 className="sheet-header-text">Skapa lediga tider</h2>
        <p className="sheet-header-paragraph">
          Är du säker på att du vill lägga till 
        </p>
        <p className="sheet-header-paragraph" style={{ marginTop: 8, fontSize: 13, opacity: 0.8 }}>
          Lägg först till tider med + knappen i rutan bakom, och spara sedan här.
        </p>
      </div>
            <div className="sheet-form-container">
              <ul className="add-timeslots-pending-list">
                {timeSlots
                  .filter((slot) => slot.newTimeSlot)
                  .map((slot) => (
                    <li key={slot.id} className="add-timeslots-pending-item">
                      <span className="add-timeslots-pending-date">{slot.date}</span>
                      <span className="cell-pill">{slot.time}</span>
                    </li>
                  ))}
              </ul>
            </div>
            
                        
        <div className="sheet-modal-footer">
               <button
          type="submit"
          className="sheet-form-submit-button"
          disabled={!hasPendingSlots || isSavingNewSlots}
          onClick={handleAvailabletimeSlotSubmit}
        >
          {isSavingNewSlots ? (<><Loader loaderSize='SMALL' bgColor='white'/>Sparar</>): (<><AdminIcon.Save width={16} height={16} fill='white'/>
          Spara tider</>)}
        </button>
        </div>
        </Modal>
    )
}
